import { lazy } from 'react';

export const retry = (fn, retriesLeft = 3, interval = 500) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval * 2).then(resolve, reject);
        }, interval);
      });
  });
};

export const lazyWithRetry = fn => lazy(() => retry(fn));

export default retry;
